import React from 'react';

import { Checkbox, Tooltip } from 'antd-v5';
import cn from 'classnames';
import { MdWarning } from 'react-icons/md';
import { Text } from 'scouting-ui/lib';
import { cssVars } from 'scouting-ui/lib/variables';

import type { ClassYouth } from '../types';
import styles from './ClassEntry.module.scss';

interface YouthOptionProps {
  youth: ClassYouth;
  checked: boolean;
  disabled: boolean;
  disabledReason?: string;
  onToggle: (memberId: number) => void;
}

export default function YouthOption(props: YouthOptionProps) {
  const { youth, checked, disabled, disabledReason, onToggle } = props;
  const locked = disabledReason !== undefined;

  const option = (
    <div
      tabIndex={locked ? 0 : undefined}
      className={cn(styles.youthOption, {
        [styles.youthOptionSelected]: checked,
        [styles.youthOptionLocked]: locked,
      })}
    >
      <Checkbox
        checked={checked}
        disabled={disabled || locked}
        onChange={() => onToggle(youth.memberId)}
      >
        <div className={styles.youthLabel}>
          <Text
            font="body-body-2"
            color={locked ? 'color-text-disabled' : undefined}
          >
            {youth.name}
          </Text>
          {locked && (
            <MdWarning
              className={styles.lockedIcon}
              color={cssVars['color-warning']}
            />
          )}
        </div>
      </Checkbox>
    </div>
  );

  if (!locked) return option;

  return <Tooltip title={disabledReason}>{option}</Tooltip>;
}
